import * as React from 'react';
const IconCalendar = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={27}
    height={30}
    fill="none"
    {...props}
  >
    <path
      fill={props.fill || '#396DFF'}
      fillRule="evenodd"
      d="M24 3h-1.5V0h-3v3h-12V0h-3v3H3a3 3 0 0 0-3 3v21a3 3 0 0 0 3 3h21c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3Zm0 24H3V10.5h21V27ZM5.25 16.5c0-2.07 1.68-3.75 3.75-3.75 2.07 0 3.75 1.68 3.75 3.75 0 2.07-1.68 3.75-3.75 3.75-2.07 0-3.75-1.68-3.75-3.75Z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconCalendar;
